import Vue from 'vue';
import chartOfAccountsTransformer from './../../transformers/chartOfAccounts';

const success = (data, resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(chartOfAccountsTransformer.fetch(errors));
};

export default (id, data) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/chart_of_accounts/${id}`, chartOfAccountsTransformer.send(data))
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/chartOfAccounts/update.js